// 申请保障金-用户发起
const userInitiateReport = () =>
  import(
    /* webpackChunkName: "initiate-report" */ '../views/claim-apply/user-initiate-report.vue'
  );

// 申请保障金
const driverInitiateReport = () =>
  import(
    /* webpackChunkName: "initiate-report" */ '../views/claim-apply/driver-initiate-report.vue'
  );

// 人身意外理赔
const personalAccident = () =>
  import(
    /* webpackChunkName: "personal-accident" */ '../views/claim-apply/personal-accident.vue'
  );

export default [
  {
    name: 'userInitiateReport',
    path: '/claims/initiate-report',
    component: userInitiateReport,
    meta: { title: '保障金申请', keepAlive: true },
  },
  {
    name: 'driverInitiateReport',
    path: '/claims/driver/initiate-report',
    component: driverInitiateReport,
    meta: { title: '保障金申请', keepAlive: true },
  },
  {
    name: 'personalAccident',
    path: '/claims/personal-accident',
    component: personalAccident,
    meta: { title: '保障金申请', keepAlive: true },
  },
];
